import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ComponentTable from '../../components/ComponentTable';
import models_V2Service from '../../services/models_V2.service';
import quizService from '../../services/quiz.service';

export const QuizStatisticPage = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const actions = [
        {
            title: t('quiz.more'),
            onClick: (_, row) => history.push(`/quizzesStatisticFranch/teacher/${row.teacher_id}`),
            outOfMenu: true,
            Icon: OpenInNewIcon,
        },
    ];
    return (
        <>
            <Typography component="h2" className="container-header" pb={1}>
                {' '}
                {t('quiz.teachersStatistics')}{' '}
            </Typography>

            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        quizService.GetQuizStatistic(false, {
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || null,
                            order: (sort && sort.order) || 'asc',
                            filter,
                        }),
                    getModel: () => models_V2Service.QuizzesStatistic(false),
                }}
                actions={actions}
                selectable={true}
                enableFilter={true}
                enableSettings
                toolbarvisible={true}
                typeTable="quizzes_statistic"
            />
        </>
    );
};
